export class CannotDeleteFileError extends Error {
  constructor() {
    super('You must be admin')
  }
}
